import React, { useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import Button from './Button'
import Modal from '../ui-elements/Modal'

type ObjectAny = {
  [key: string]: any
}


type Props = {
  deleteFunction: any
  functionParams: any
  layout?: string
  size?: 'big' | 'small'
  fullwidth?: boolean
  buttonText?: string
  modalText?: string
  variant?: 'gray' | 'warning' | 'x-icon'
}

function DeleteButton({
  deleteFunction,
  functionParams,
  layout,
  size,
  fullwidth = true,
  buttonText = 'Delete',
  modalText = 'Are you sure you want to delete?',
  variant = 'warning'
}: Props) {


  const [showConfirm, setShowConfirm] = useState(false)

  return <>

    {variant === 'x-icon' && <button
      onClick={(e: any) => {
        e.stopPropagation()
        setShowConfirm(true)
      }}
      className={`top-0 right-0 absolute mt-1 mr-1 outline-none border-none cursor-pointer rounded bg-gray-300 w-6 h-6 font-white flex items-center justify-center hover:opacity-80`}
    >✕</button>}


    {variant !== 'x-icon' && <Button
      onClick={(e: any) => {
        e.stopPropagation()
        setShowConfirm(true)
      }}
      text={buttonText}
      variant={variant}
      size={size}
      fullwidth={fullwidth}
      data-prevent-close={true}
    />}

    {showConfirm && <Modal>
      <p className={`text-center text-black font-normal text-sm`}>{modalText}</p>

      <div className={`mt-3 flex items-center flex-row gap-2`}>
        <Button
          onClick={() => {
            setShowConfirm(false)
            deleteFunction(functionParams)
          }}
          variant={'warning'}
          text={'Confirm'}
          size={size}
        />
        <Button

          onClick={() => {
            setShowConfirm(false)
          }}
          variant={'gray'}
          text={'Cancel'}
          size={size}
        />
      </div>
    </Modal>}

  </>
}

export default DeleteButton